var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUpGreen = function SvgArrowUpGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.454 5.673 1.432-1.432L5.147 1.98l.52-.52h-1.21A193627.175 193627.175 0 0 0 8.15 5.154l.52.519c.316.316.897.34 1.209 0 .314-.342.338-.872 0-1.21L8.447 3.031 6.186.77l-.52-.52a.868.868 0 0 0-1.21 0L3.026 1.684l-2.26 2.26-.519.52c-.316.317-.34.898 0 1.21.34.312.87.338 1.208 0Z",
    fill: "#58B847"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.208.856V12.862c0 .203-.002.408 0 .611v.026c0 .446.393.876.855.855.464-.022.855-.377.855-.855V1.493c0-.203.002-.409 0-.612V.856c0-.447-.393-.877-.855-.855-.464.021-.855.376-.855.855Z",
    fill: "#58B847"
  })));
};
export default SvgArrowUpGreen;